import React, { FC, useState } from "react";
import { css } from "@emotion/css";
import useTheme from "evcharging/hooks/useTheme";
import { Theme } from "evcharging/app/themes";
import RatesPlanDetails from "containers/retail/sections/energy-rates-3/RatesPlanDetails";
import { Plan } from "services/quotes/types";

interface RatesMoreDetailsProps {
  plan: Plan;
}

const RatesMoreDetails: FC<RatesMoreDetailsProps> = (props) => {
  const { plan } = props;
  const theme = useTheme();
  const styles = createStyles(theme);
  const [open, setOpen] = useState<boolean>(false);
  const onToggle = () => setOpen(!open);

  return (
    <div className={styles.root}>
      <button className={styles.buttonGray} onClick={onToggle} aria-label="More Details">
        <div>{open ? "Less Details" : "More Details"}</div>
      </button>
      {open && (
        <div className={styles.nested}>
          <RatesPlanDetails plan={plan} />
        </div>
      )}
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    z-index: 900;
    position: relative;
    cursor: pointer;
    max-width: 346px;
    margin: 0 auto;

    :hover {
      color: ${theme.colors.accent};
    }
  `,
  nested: css`
    position: absolute;
    bottom: 45px;
    right: 0;
    min-width: 300px;
    background: #ffffff;
    box-shadow: 0 11px 23px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: 1px #ddd solid;
    padding: 8px 0;
  `,
  buttonGray: css({
    width: "100%",
    minWidth: 116,
    border: "none",
    background: "none",
    padding: 10,
    fontSize: 16,
    fontFamily: "Mulish, sans-serif !important",
    fontWeight: 700,
    lineHeight: 1.75,
    borderRadius: "6px",
    textTransform: "inherit",
    boxShadow: "none",
    transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    cursor: "pointer",
    color: "#93979B",
    hover: {
      backgroundColor: "#f7f8fa"
    }
  }),
});

export default RatesMoreDetails;
